export const handleTildedField = (value: string) => `${value}`.split('~')[0]

export default handleTildedField
